<div class="comment" data-cy="commented-item">
  <div class="user">
    <div class="user-info">
      <img data-cy="commented-teacher-avatar" [src]="assessment.create_user.avatar" />
      <div class="user-name">
        @if (isTeacher()) {
          <div class="teacher-name">
            <p class="truncate-text" data-cy="commented-teacher-name">{{ assessment.create_user.name }}</p>
            <p>先生</p>
          </div>
        } @else {
          <p
            class="student-name truncate-text"
            data-cy="commented-student-name"
            [class.spen-util-link]="assessment.create_user.viewer_permission"
            [routerLink]="assessment.create_user.viewer_permission ? ['/students/teacher', assessment.create_user.id] : []"
          >
            {{ assessment.create_user.name }}
          </p>
          <p class="student-class" data-cy="commented-student-class">
            {{ assessment.create_user.className }}{{ assessment.create_user.attendanceNumber }}番
          </p>
        }
      </div>
    </div>
    @if (canEdit) {
      <a class="delete-edit spen-util-link" data-cy="commented-edit-button" (click)="onEditAssessment()">
        <i class="fa fa-pencil"></i><span>変更・削除</span>
      </a>
    }
  </div>

  <div class="content-comment">
    <p class="time-comment" data-cy="commented-created-at">{{ assessment.created_at }}</p>
    <app-read-more [content]="assessment.content"></app-read-more>
    @if (assessment.is_updated) {
      <span class="updated-text" data-cy="commented-is-updated">（変更済み）</span>
    }
  </div>
</div>
